//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2ImportProcs', {
//        templateUrl: 'views/components/views/p2ImportProcs/p2ImportProcs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'p2ImportProcsService', function (stateService, p2ImportProcsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListImportProcedures: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadImportProcedures() {
//                vm.model.itemsListImportProcedures = await p2ImportProcsService.listImportProcedures({ show_in_excelimport: 'A' });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'p2importproc':
//                        go({ p2_importproc_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadImportProcedures();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
